import * as yup from "yup";

export const companySchema = yup
  .object({
    nome: yup.string().required("Nome fantasia é obrigatório"),
    razao_social: yup.string().required("Razão social é obrigatória"),
    telefone: yup.string().required("Telefone é obrigatório"),
  })
  .required();

export const customerSchema = yup
  .object({
    nome: yup.string().required("Nome é obrigatório"),
    telefone: yup.string().required("Telefone é obrigatório"),
    data_nascimento: yup.string(),
  })
  .required();

export type CompanyFormData = yup.InferType<typeof companySchema>;
export type CustomerFormData = yup.InferType<typeof customerSchema>;
export type FormData = Partial<CompanyFormData & CustomerFormData>;
